var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5009 9.85417H13.9801V5.31852C13.9801 4.27966 13.1379 3.4375 12.0991 3.4375C11.0602 3.4375 10.2181 4.27966 10.2181 5.31852V6.42864C10.2181 7.78229 9.80885 9.02978 8.66753 9.6491C7.52621 10.2684 7.10568 10.9892 7.10571 11.6221L7.10593 15.5375C7.10593 17.2082 8.46027 18.5625 10.1309 18.5625H15.575C16.0474 18.5994 16.5005 18.4045 16.8671 18.0379C17.2343 17.6707 17.5016 17.1465 17.6408 16.5523L18.559 11.9616C18.5619 11.9468 18.5634 11.9318 18.5634 11.9167C18.5634 11.3697 18.3461 10.8451 17.9593 10.4583C17.5726 10.0715 17.0479 9.85417 16.5009 9.85417Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66732 9.85775C3.03449 9.85775 2.52148 10.3708 2.52148 11.0036V17.4211C2.52148 18.054 3.03449 18.567 3.66732 18.567H5.04232C5.67514 18.567 6.18815 18.054 6.18815 17.4211V11.0036C6.18815 10.3708 5.67514 9.85775 5.04232 9.85775H3.66732Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.299033ea1ebe1ab0efaaeed6f081aa26.svg";
export { ForwardRef as ReactComponent };